import { DropDownBlackBackground } from "@components/atoms/dropdown-black-background/dropdown-black-background";
import { Button } from "@components/atoms/buttons/button/button";
import { Input } from "@components/atoms/input/input";
import React, { useState } from "react";
import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";
import { SubHeader } from "@components/atoms/sub-header/sub-header";
import { SubTitle } from "@components/atoms/sub-title/sub-title";
import styles from "./configuration-manager-page.module.scss";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { FluidToFixSplitContainer } from "@components/templates/layouts/fluid-to-fix-split-container/fluid-to-fix-split-container";
import { useI18N } from "@src/language/language-context";

export const CreateConfigurationFile = ({
  onCancel,
}: {
  onCancel: () => void;
}) => {
  const i18n = useI18N();
  const [ipHost, setIpHost] = useState("");
  const [port, setPort] = useState("");

  return (
    <>
      <SubHeader variant={["lower-radius", "less-padding"]}>
        <SubTitle
          text={i18n("pages.configurationManager.renderConfigurationTemplate")}
        />
      </SubHeader>
      <Spacer16 />
      <div
        className={styles["configuration-manager-page__create-configuration"]}
      >
        <label
          htmlFor="serverType"
          className={styles["configuration-manager-page__label"]}
        >
          <span className={styles["configuration-manager-page__label-text"]}>
            {i18n("pages.configurationManager.serverType")}
          </span>
          <DropDownBlackBackground
            id="serverType"
            // hardcoding the value for now, because we don't support other options at the moment
            dropDownValue="opcua"
            dropDownValuesAndLabels={{
              opcua: i18n("pages.configurationManager.opcUa"),
            }}
            callback={() => null}
          />
        </label>
        <Spacer16 />
        <Input
          labelText={i18n("pages.configurationManager.ipHost")}
          inputPlaceHolder={"example.com"}
          inputValue={ipHost}
          onChangeFunc={(e) => setIpHost(e.target.value)}
        />
        <Input
          labelText={i18n("pages.configurationManager.port")}
          inputPlaceHolder={"4840"}
          inputValue={port}
          onChangeFunc={(e) => setPort(e.target.value)}
        />

        <FluidToFixSplitContainer lessPadding>
          <Button
            text={i18n("pages.configurationManager.cancel")}
            variant="secondary"
            fun={() => onCancel()}
          />
          {/* Not supported yet, so putting a placeholder for now */}
          <Button
            text={i18n("pages.configurationManager.create")}
            fun={() => errorSnackbar("Not implemented")}
          />
        </FluidToFixSplitContainer>
      </div>
    </>
  );
};
